import API from 'shared/constants/api';
import { execPostRequest, getCleanDeviceId } from './utils';

/**
 * Fetch car's temperature
 * @param {Number} deviceId 
 * @param {Function} fetch 
 * @returns 
 */
export const fetchUsersTemperature = async (deviceId, fetch) => {
  const body = { deviceId: getCleanDeviceId(deviceId) };

  let temperature = 0;
  let temperatureData = {};

  try {
    temperatureData = await execPostRequest(
      API.ADVERT.LEASING.GET_TEMPERATURE,
      body,
      fetch,
      {},
      '',
    );
    temperature = temperatureData && temperatureData.temperature ? temperatureData.temperature : 0;
  } catch (err) {
    console.log('Temperature not ok');
  }

  // temperature: 0.35
  if (temperature) {
    console.log('temperatureData', temperatureData);
  } else {
    console.log('Temperature error', temperatureData);
  }
  return temperature;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/leasing/finup.js